<script setup lang="ts">
import {computed, onMounted, ref} from 'vue';
import type {Praeparat} from "@/types/otc/praeparat";
import type {Dokument} from "@/types/otc/dokument";
import {downloadsService} from "@/api/downloads.service";
import {resourcesService} from "@/api/resources.service";

interface Props {
  praeparat: Praeparat;
  dictionary: Record<string,string>
}
const props = defineProps<Props>();
const baseUrl = ref<string>('');

const docList = computed<Dokument[]>(() => {
  return ( props.praeparat.dokumente || []) as Dokument[];
});

const isAllgDokument = (doc: Dokument) => doc.isAllgDokument ?? false;

const getDocUrl = (doc: Dokument) => {
  if(!baseUrl.value || !doc.dateiKey) return '';

  // --------------------------------------------------
  //TODO Wieder entfernen nur für Lokale Entwicklung (Manu)
  // --------------------------------------------------
  if (baseUrl.value.startsWith('http://localhost:57444')) {
    baseUrl.value = baseUrl.value.replace('http://localhost:57444', 'https://fachwelt.aliud.de');
  }
  // --------------------------------------------------
  
  const url = new URL(baseUrl.value, window.location.origin);
  url.searchParams.set('key', doc.dateiKey);
  return url.toString();
};


onMounted(async () => {
  try {
    baseUrl.value = await resourcesService.publicImageApiUrl();
    console.log('baseUrl', baseUrl.value);
  } catch (error) {
    console.error('Fehler beim Laden der baseUrl:', error);
  }
});

const linkLabel = (doc: Dokument): string => {
  if (isAllgDokument(doc)) {
    return doc.titel ?? '';
  }
  const key = 'PRODUKTE_DOKUMENTE_' + (doc.name ?? '');
  return props.dictionary[key] ?? doc.name ?? 'Dokument';
};

const linkTitle = (doc: Dokument): string => {
  const label = linkLabel(doc);
  const praepName = (props.praeparat.name) as string;
  return `${label} ${praepName}.pdf`;
};


</script>

<template>
  
    <div class="downloads" v-if="docList.length">
      <div v-for="doc in docList">
        <p class="download praeparat-download">
          
          <a
              :href="getDocUrl(doc)"
              target="_blank"
              :title="doc.name"
          >
          {{doc.name}}
          </a>
          
          <span
              v-if="isAllgDokument(doc) && doc.beschreibung"
              v-html="doc.beschreibung"
          />
        </p>
      </div>
    </div>
    
</template>

<style scoped>

</style>